import React from "react";
import Card from "../../../Card";
import MUITextField from "@mui/material/TextField";
import MUIGrid from "@mui/material/Grid2";

export default function CardAdminDashboardGeneral(props) {
  const renderContent = () => {
    return (
      <MUIGrid container spacing={2}>
        <MUIGrid
          size={{
            xs: 12,
            sm: 6,
            md: 4,
          }}
        >
          <MUITextField
            value={props.dashboard?.name ?? ""}
            autoFocus={true}
            size="small"
            label="Name"
            variant="standard"
            fullWidth={true}
            onBlur={(e) => props.onChange({ name: e.target.value.trim() })}
            onChange={(e) => props.onChange({ name: e.target.value })}
            required={true}
            error={props.validationIssues.name ? true : false}
            helperText={
              props.validationIssues.name ? props.validationIssues.name : ""
            }
            slotProps={{
              htmlInput: {
                maxLength: 255,
              },

              inputLabel: { shrink: true },
            }}
          />
        </MUIGrid>
        <MUIGrid
          size={{
            xs: 12,
            sm: 6,
            md: 8,
          }}
        >
          <MUITextField
            value={props.dashboard?.description ?? ""}
            size="small"
            label="Description"
            variant="standard"
            fullWidth={true}
            onBlur={(e) =>
              props.onChange({ description: e.target.value.trim() })
            }
            onChange={(e) => props.onChange({ description: e.target.value })}
            required={false}
            error={props.validationIssues.description ? true : false}
            helperText={
              props.validationIssues.description
                ? props.validationIssues.description
                : ""
            }
            slotProps={{
              htmlInput: {
                maxLength: 1024,
              },

              inputLabel: { shrink: true },
            }}
          />
        </MUIGrid>
      </MUIGrid>
    );
  };

  return <Card renderContent={renderContent} getTitle={() => "General"} />;
}
